import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Meta = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = "Unicon - Mist Separator | Candle Filter"; // Reset title if necessary
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Helmet>
      <title>Unicon - Mist Separator | Candle Filters</title>
      <meta name="title" content="UniConinter - Mist Separator | Candle Filters"/>
<meta name="description" content="Unicon's mist separators and candle filters offer top-notch liquid and particle separation, ensuring reliable performance across various applications."/>
<meta name="keywords" content="Advanced Mist Separator & Candle Filters"/>
<meta name="robots" content="index,follow"/>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
<meta name="language" content="English"/>
<meta property="og:title" content="UniConinter - Mist Separator | Candle Filters"/>
<meta property="og:site_name" content="Unicon Mist Separator & Candle Filters"/>
<meta property="og:url" content="https://www.uniconinter.com/mist-separators"/>
<meta property="og:description" content="Unicon's mist separators and candle filters offer top-notch liquid and particle separation, ensuring reliable performance across various applications."/>
<meta property="og:type" content="product"/>
<meta property="og:image" content="https://www.uniconinter.com/images/products/mist-separators-candle-filters/sec1.jpg"/>

    </Helmet>
  );
};

export default Meta;
